/**
 * Mentors' submissions pages: what waits for review across their cohorts and
 * 1:1 students, and per module the assessment results and assignment
 * submissions with analytics.
 *
 * `kind` is "topic" for a 1:1 student's module or "template" for a cohort's.
 */

import api from "../../api";

const BASE = "api/submissions";

export { errorMessage } from "../ContentBank/contentBankApi";

export const getOverview = async () => (await api.get(`${BASE}/`)).data;

export const getModuleReport = async (kind, moduleId) => (await api.get(`${BASE}/${kind}/${moduleId}/`)).data;

/** status: "reviewed" | "needs_revision"; score 0-100 or "" for none. */
export const reviewAssignment = async (kind, moduleId, submissionId, { status, score, feedback }) =>
  (await api.post(`${BASE}/${kind}/${moduleId}/assignments/${submissionId}/review/`, { status, score, feedback })).data;

export const assignmentFileUrl = async (kind, moduleId, submissionId) =>
  (await api.get(`${BASE}/${kind}/${moduleId}/assignments/${submissionId}/download/`)).data;

/** Where a mentor reads one student's answers and marks them. */
export const reviewAnswersPath = (row) =>
  `/dashboard/workspace/${row.course_id}/assessment/${row.topic_id}/review/${row.course_id}`;

/** The submissions page for one module. */
export const moduleReportPath = (kind, moduleId, tab = "assessments") =>
  `/dashboard/submissions?kind=${kind}&module=${moduleId}&tab=${tab}`;
